import { render, staticRenderFns } from "./tribeJoin.vue?vue&type=template&id=4a42ece8&scoped=true&"
import script from "./tribeJoin.vue?vue&type=script&lang=js&"
export * from "./tribeJoin.vue?vue&type=script&lang=js&"
import style0 from "./tribeJoin.vue?vue&type=style&index=0&id=4a42ece8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a42ece8",
  null
  
)

export default component.exports